<script setup lang="ts">
import AppButton from "@/components/ui-kit/button/AppButton.vue";

const props = defineProps<{
	loading?: boolean
}>()

const emit = defineEmits<{
	(e: 'cancel'): void,
	(e: 'confirm'): void,
}>()
</script>

<template>
	<div class="delete-project-confirm">
		<div class="delete-project-confirm__title">
			Вы действительно хотите удалить проект?
		</div>
		<div class="delete-project-confirm__actions">
			<app-button
				class="delete-project-confirm__actions-button"
				type="secondary"
				label="Отмена"
				@click="emit('cancel')"
			/>
			<app-button
				class="delete-project-confirm__actions-button"
				label="Удалить"
				:disabled="props.loading"
				@click="emit('confirm')"
			/>
		</div>
	</div>
</template>

<style scoped lang="scss">
.delete-project-confirm {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 12px;
	gap: 8px;

	&__title {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		line-height: 18px;
		font-weight: 600;
		color: #4D4D4D;
		text-align: center;
	}

	&__actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;

		&-button {
			flex: 1;
		}
	}
}
</style>
